import { render } from "./Auctions.vue?vue&type=template&id=a143ea7c&scoped=true"
import script from "./Auctions.vue?vue&type=script&lang=js"
export * from "./Auctions.vue?vue&type=script&lang=js"

import "./Auctions.vue?vue&type=style&index=0&id=a143ea7c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a143ea7c"]])

export default __exports__